/* "Route starten": Apple Kaarten op iPhone/iPad, anders Google Maps. Met
   coördinaten als die er zijn, anders op adres. Er gaat niets naar onze server. */

export interface Plek { naam: string; adres: string; postcode: string; plaats: string; lat: number | null; lon: number | null }

export const isApple = () => /iPad|iPhone|iPod|Macintosh/.test(navigator.userAgent) && 'ontouchend' in document

export function googleRoute(p: Plek): string {
  const doel = p.lat && p.lon ? `${p.lat},${p.lon}` : `Truckwash ${p.adres} ${p.postcode} ${p.plaats}`
  return `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(doel)}&travelmode=driving`
}

export function appleRoute(p: Plek): string {
  const doel = p.lat && p.lon ? `${p.lat},${p.lon}` : `${p.adres} ${p.postcode} ${p.plaats}`
  return `https://maps.apple.com/?daddr=${encodeURIComponent(doel)}&dirflg=d&q=${encodeURIComponent('Truckwash ' + p.naam)}`
}

/** Afstand in km, hemelsbreed. */
export function afstand(a: { lat: number; lon: number }, b: { lat: number; lon: number }): number {
  const r = (x: number) => (x * Math.PI) / 180
  const d = Math.sin(r(b.lat - a.lat) / 2) ** 2 + Math.cos(r(a.lat)) * Math.cos(r(b.lat)) * Math.sin(r(b.lon - a.lon) / 2) ** 2
  return 6371 * 2 * Math.asin(Math.sqrt(d))
}
